import React from 'react'
import { Editor } from 'draft-js'
import withUnsavedWorkWarning from './HOC/withUnsavedWorkWarning'
import withLoomIntegration from './HOC/withLoomIntegration'
import makeFullEditorWithLoom from './HOC/makeFullEditorWithLoom'
import RichEditor from './RichEditor'

export { default as RichEditor } from './RichEditor'

export const RichEditorUnsavedWorkWarning = withUnsavedWorkWarning(RichEditor)

export const MinimalRichEditorWithLoom =
  withUnsavedWorkWarning(withLoomIntegration(RichEditor))

export const PlaintextEditorWithLoom = makeFullEditorWithLoom(Editor, false)

// If we ever want a rich editor with full loom support, uncomment this line:
// export const RichEditorWithLoom = makeFullEditorWithLoom(RichEditor, true)
